<template>
  <v-list class="py-0 cross-row">
    <v-divider></v-divider>
    <template v-if="createBtn">
      <v-list-item v-ripple @click="$emit('onCreate')">
        <v-list-item-content>
          <v-list-item-title class="body-2">+ 新增健檢報告</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider v-if="reports.length > 0"></v-divider>
    </template>
    <template v-for="(report, index) in reports">
      <v-list-item :key="report._id" v-ripple @click="$emit('onSelect', report._id)">
        <v-list-item-content>
          <v-list-item-title class="d-flex flex-row body-2">
            <div v-text="report.date"></div>
            <div class="flex-grow-1"></div>
            <div class="text-right" v-if="report.doctor">{{ `${report.doctor}醫師` }}</div>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider v-if="index < reports.length" :key="`${report._id}-divider`"></v-divider>
    </template>
    <template v-if="reports.length === 0">
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="body-2">無健檢報告</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </template>
  </v-list>
</template>
<style scoped>
.cross-row .v-list-item:nth-child(4n) {
  background: #fafbfc;
}
</style>

<script>
export default {
  props: ["clinic", "createBtn", "doctor", "userName", "userPhone", "petId"],
  data: () => ({
    reports: []
  }),
  methods: {
    async getReport(petId) {
      let response = await this.$ajax.get(
        `${this.$config.apiUrl}/${this.clinic}/reports/${petId}/0`
      );
      this.reports = response.data;
    }
  },
  mounted() {
    this.getReport(this.petId);
  }
};
</script>

<style></style>
